import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import clone from 'lodash/clone';
import './handleSelector.scss';
import isArray from "lodash/isArray";

class HandleSelectorCtrl {
    constructor($sce, imagesService, dataService, handlesService, apiService, $scope, $rootScope, $filter) {
        this.multiSelect = false;
        this.handlesService = handlesService;
        this.moreInfo = null;
        this.sce = $sce;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.apiService = apiService;
        this.$rootScope.$on('windowFunctionChangeEvent', () => this.getHandlesSides());
        this.$rootScope.$on('dimensionsChangeEvent', () => this.changeHandleOnBasementWindowRule());

        if (angular.isUndefined(this.selectedHandleInsideAccessories)) {
            this.selectedHandleInsideAccessories = [];
        }

        if (angular.isUndefined(this.selectedHandleOutsideAccessories)) {
            this.selectedHandleOutsideAccessories = [];
        }
    }

    getSelectedHandle() {
        return this.handlesService.getHandle(this.selectedOptions);
    }

    filterHandleAccessories(side = 'inside') {
        const handle = this['selectedHandle' + this.capitalize(side)];
        this['handle' + this.capitalize(side) + 'Accessories'] = this.allAccessories.filter(el => handle.attributes.handleAccessories.includes(el.id));
    }

    /**
     * Toggle handle option
     *
     * @param {Object} option
     * @returns {Boolean}
     * @memberof HandleSelectorCtrl
     */
    toggleHandleOption(option) {
        if (
            this.dataService.isBalconyDoorOrEntranceDoor() &&
            Number(option.attributes.accessoryType) === 20
        ) {
            if (this.handlesService.isHandleOptionSelected(option.id)) {
                this.apiService.setUniversalKeyInCart(0);
            } else {
                this.apiService.setUniversalKeyInCart(1);
            }
        }
        this.handlesService.toggleHandleOption(option.id);
        this.dataService.updateSelectedOptions(
            'handleOptions',
            this.handlesService.selectedHandleOptions,
            'handleOptions',
            true,
        );
        return true;
    }

    isHandleOptionSelected(id) {
        return this.handlesService.isHandleOptionSelected(id);
    }

    getHandleColors() {
        return this.handlesService.getHandleColors();
    }

    setHandleColor(option) {
        // Set handle color in js object
        if (typeof option !== 'undefined') {
            this.handlesService.setHandleColor(option.id);

            // Update configuration data object
            this.dataService.updateSelectedOptions(
                'handleColor',
                this.handlesService.selectedHandleColor,
                'handleColor',
                true,
            );
        }
    }

    isHandleColorSelected(id) {
        return this.handlesService.isHandleColorSelected(id);
    }

    /**
     * Reset button functionality
     */
    reset() {
        this.selectedHandleInsideAccessories = this.dataService.reset(
            'handleInsideAccessories',
            false
        );
        this.selectedHandleOutsideAccessories = this.dataService.reset(
            'handleOutsideAccessories',
            false
        );
        this.selectedHandleOutside = this.handlesService.getHandle(
            this.dataService.reset(
                'handleOutside',
                false
            )
        );
        this.selectedHandleInside = this.handlesService.getHandle(
            this.dataService.reset(
                'handleInside'
            )
        );
        this.filterHandleAccessories('inside');
        this.filterHandleAccessories('outside');
        this.setHandlePreview('inside');
        this.setHandlePreview('outside');
        this.apiService.setUniversalKeyInCart(0);
        this.handlesService.setHandleColors(this.selectedHandleInside.relationships.colors);
        this.setHandleColor(this.selectedHandleInside.relationships.colors[0]);
        this.handlesService.selectedHandleOptions = [];
        this.dataService.updateSelectedOptions('handleOptions', this.handlesService.selectedHandleOptions, 'handleOptions', false);
        this.$rootScope.$emit('colorChangeEvent');
    }

    onInit() {
        this.moreInfo = this.dataService.getMoreInfo(this.defaultSelectedIdFieldName);
        this.trustHtml();
        this.allAccessories = this.dataService.getAttributeOptions('handleAccessories');
        if (this.canHaveDifferentHandlesBothSides()) {
            this.handlesInside = this.options.filter(el => el.attributes.can_be_inside);
            this.handlesOutside = this.options.filter(el => el.attributes.can_be_outside);
            this.selectedHandleOutside = this.dataService.getSelectedOption('handleOutside', 'handle');
            this.selectedHandleOutsideAccessories = this.dataService.getSelectedOptionId('handleOutsideAccessories').map(el => el.id);
            this.handleOutsideAccessories = this.allAccessories.filter(el => this.selectedHandleOutside.attributes.handleAccessories.includes(el.id));
            this.setHandlePreview('outside');
        } else {
            this.handlesInside = this.options.filter(el => el.attributes.can_be_inside);
        }
        this.selectedHandleInside = this.dataService.getSelectedOption('handleInside', 'handle');
        this.selectedHandleInsideAccessories = this.dataService.getSelectedOptionId('handleInsideAccessories').map(el => el.id);
        this.handleInsideAccessories = this.allAccessories.filter(el => this.selectedHandleInside.attributes.handleAccessories.includes(el.id));
        this.setHandlePreview('inside');
        this.getHandlesSides();
        this.changeHandleOnBasementWindowRule();

        this.selectedHandle = this.getSelectedHandle();
    }

    getHandleOptions() {
        const options = this.handlesService.getHandleOptions();
        const result = [];

        options.forEach((option) => {
            if (!option.attributes.isHidden &&
                option.attributes.accessoryType === 20 &&
                (this.dataService.getSelectedOptionId('handleInside') !== 129 ||
                    this.dataService.getSelectedOptionId('handleOutside') !== 129)
            ) {
                result.push(option);
            }
        });
        return result;
    }

    getHandlesSides() {
        if (this.dataService.getAttributes().windowFunctionId !== 11) {
            this.handlesSides = [];
            this.selectedHandlesSide = null;
            return false;
        }
        this.handlesSides = [{
                name: 'LEFT',
                img: '/img/handle_left.png',
                id: '1',
            },
            {
                name: 'TOP',
                img: '/img/handle_top.png',
                id: '3',
            },
            {
                name: 'RIGHT',
                img: '/img/handle_right.png',
                id: '2',
            },
        ];

        const hingeSide = this.dataService.getSelectedOptionId('hingeSide');
        this.selectedHandlesSide = this.handlesSides.find(h => h.id == hingeSide);
    }

    isSelectedHandlesSide(data) {
        return this.selectedHandlesSide.id == data.id;
    }

    /**
     * Check whether handle option is selected
     *
     * @param {Object} data Data object
     * @returns boolean
     */
    isSelectedHandlesOption(data) {
        return this.selectedHandlesOption.id == data.id;
    }

    updateOption(data) {
        this.selectedHandlesSide = data;
        this.dataService.updateSelectedOptions('hingeSide', data.id, 'hingeSide', false);
        this.$rootScope.$emit('colorChangeEvent');
    }

    trustHtml() {
        forEach(this.options, (el) => {
            if (angular.isDefined(el.attributes.subtitle)) {
                this.sce.trustAsHtml(el.attributes.subtitle);
            }
        });
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedOptions = [];
    }

    isBlocked(option) {
        return option.blocked;
    }

    selectHandle(handle, side) {
        const type = 'handle' + this.capitalize(side);

        if (this.dataService.getProductType() === 'door') {
            if (angular.isDefined(handle.relationships.colors) && handle.relationships.colors.length > 0) {
                this.handlesService.setHandleColors(handle.relationships.colors);
                this.setHandleColor(handle.relationships.colors[0]);
            }
        }
        this['selectedHandle' + this.capitalize(side)] = handle;
        this.filterHandleAccessories(side);
        this.filterSelectedHandleAccessories(side);
        this.setHandlePreview(side);

        this.dataService.updateSelectedOptions(
            type,
            handle.id,
            type,
            false,
        );
        this.$rootScope.$emit('updateDrawing');
    }

    filterSelectedHandleAccessories(side) {
        const handle = this['selectedHandle' + this.capitalize(side)];
        const selectedAccessories = this['selectedHandle' + this.capitalize(side) + 'Accessories'].filter(el => handle.attributes.handleAccessories.includes(el));
        this['selectedHandle' + this.capitalize(side) + 'Accessories'] = selectedAccessories;
        this.dataService.updateSelectedOptions(
            'handle' + this.capitalize(side) + 'Accessories',
            selectedAccessories,
            'handleAccessories',
            false,
        );
    }

    capitalize(string) {
        if (typeof string !== 'string') return '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    getCaptionImage(type) {
        return this.imagesService.getCaptionImageUrl(this.defaultSelectedIdFieldName, type);
    }

    getImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    getPreviewImage(side = 'inside') {
        return this.imagesService.getFullUrl(this['handle' + this.capitalize(side) + 'Preview'].attributes.fullImgSrc);
    }

    getPreviewName(side = 'inside') {
        return this['handle' + this.capitalize(side) + 'Preview'].attributes.name;
    }

    getPreviewPrice(side = 'inside') {
        let price = '';
        const handle = this['handle' + this.capitalize(side) + 'Preview'];
        if (handle.attributes.price != null) {
            if (this.dataService.data.rules.handle_quantity == 1) {
                if (this.dataService.isB2bMode() && !this.dataService.priceSwitchState()) {
                    price = '+' + handle.attributes.netPriceAfterDiscount + 'kr';
                } else {
                    price = '+' + handle.attributes.priceAfterDiscount + 'kr';
                }
            } else if (this.dataService.data.rules.handle_quantity > 1) {
                price = '+' +
                    (((this.dataService.isB2bMode() && !this.dataService.priceSwitchState()) ? handle.attributes.netPriceAfterDiscount : handle.attributes.priceAfterDiscount) * this.dataService.data.rules.handle_quantity) +
                    ' kr (+' + ((this.dataService.isB2bMode() && !this.dataService.priceSwitchState()) ? handle.attributes.netPriceAfterDiscount : handle.attributes.priceAfterDiscount) +
                    ' kr ' +
                    this.$filter('lowercase')(this.$filter('translate')('PER_ITEM')) +
                    ')';
            }
        }
        return price;
    }

    canHaveDifferentHandlesBothSides() {
        return this.dataService.data.productInfo.canHaveDifferentHandlesBothSides;
    }

    getHandleSide() {
        return this.handlesService.handleSide;
    }

    setHandlePreview(side, handle) {
        if (handle) {
            this['handle' + this.capitalize(side) + 'Preview'] = handle;
        } else {
            this['handle' + this.capitalize(side) + 'Preview'] = this['selectedHandle' + this.capitalize(side)];
        }
    }

    isAvailable(option) {
        if (option.id === '7' && this.dataService.jsonService.blindsError) {
            return true;
        }
        return false;
    }

    openDescriptionModal(option) {
        this.openModalCallback({
            modalTitle: option.attributes.name,
            modalContent: option.attributes.description,
            modalImgSrc: option.attributes.imgSrc,
        });
    }

    openModal(option) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: option.attributes.modalTitle,
                modalContent: option.attributes.modalContent,
                modalImgSrc: option.attributes.modalImgSrc
            });
        }
    }

    openMoreInfoModal(moreInfo) {
        if (isFunction(this.openModalCallback)) {
            this.openModalCallback({
                modalTitle: moreInfo.attributes.name,
                modalContent: moreInfo.attributes.content,
            });
        }
    }

    toggleInsideAccessorySelected(id) {
        if (this.selectedHandleInsideAccessories.indexOf(id) !== -1) {
            this.selectedHandleInsideAccessories.splice(this.selectedHandleInsideAccessories.indexOf(id), 1);
        } else {
            this.selectedHandleInsideAccessories.push(id);
        }

        this.dataService.updateSelectedOptions('handleInsideAccessories', this.selectedHandleInsideAccessories);
    }

    isInsideAccessorySelected(id) {
        if (isArray(this.selectedHandleInsideAccessories)) {
            return this.selectedHandleInsideAccessories.indexOf(id) !== -1;
        }

        return this.selectedHandleInsideAccessories == id; // eslint-disable-line eqeqeq
    }

    toggleOutsideAccessorySelected(id) {
        if (this.selectedHandleOutsideAccessories.indexOf(id) !== -1) {
            this.selectedHandleOutsideAccessories.splice(this.selectedHandleOutsideAccessories.indexOf(id), 1);
        } else {
            this.selectedHandleOutsideAccessories.push(id);
        }

        this.dataService.updateSelectedOptions('handleOutsideAccessories', this.selectedHandleOutsideAccessories);
    }

    isOutsideAccessorySelected(id) {
        if (isArray(this.selectedHandleOutsideAccessories)) {
            return this.selectedHandleOutsideAccessories.indexOf(id) !== -1;
        }

        return this.selectedHandleOutsideAccessories == id; // eslint-disable-line eqeqeq
    }

    changeHandleOnBasementWindowRule() {
        let handleSelection = this.dataService.getSelectedOption('handleInside', 'handle');

        if (this.dataService.displayBasementWindowRuleNotice && !handleSelection.attributes.only_for_basement_windows) {
            let selectedHandle = this.handlesInside.filter(handle => handle.attributes.only_for_basement_windows)[0];
            this.selectHandle(selectedHandle, 'inside');
        }
    }

    blockHandleOnBasementWindowRule(handle) {
        return (this.dataService.displayBasementWindowRuleNotice && !handle.attributes.only_for_basement_windows);
    }
}

HandleSelectorCtrl.$inject = ['$sce', 'imagesService', 'dataService', 'handlesService', 'apiService', '$scope', '$rootScope', '$filter'];

export default HandleSelectorCtrl;